import http from '../../../utils/fetch';
import updownfile from "../../../utils/updownfile";
export default {

    baseurl:'/api/swyl/v1/manager/SpecialController',

    tejialist:'/api/swyl/v1/tejiashitulist/viewSpecialList',

    fileurl:'/api/file/fileopt',

    tejiachanpin:'/api/swyl/v1/detail/specialOfferDetail',

    seleproNum(q){
        return http({
            url: this.baseurl + '/seleproNum',
            method: 'post',
            params: q
        });
    },

    saveSpecialDet(q){
        return http.post(this.baseurl + '/saveSpecialDet', q);
    },

    shanchuzancun(q){
        return http({
            url: this.baseurl + '/shanchuzancun',
            method: 'post',
            params: q
        });
    },

    xiugaishenqing(q){
        return http({
            url: this.baseurl + '/xiugaishenqing',
            method: 'post',
            params: q
        });
    },

    updateAvaiNumberById(q){
        return http({
            url: this.tejiachanpin + '/updateAvaiNumberById',
            method: 'post',
            data: q
        });
    },
    selectDetailList(id){
        return http({
            url: this.tejiachanpin + '/selectDetailList?id='+id,
            method: 'post',
        });
    },

    tejiaxiangqing(q){
        return http({
            url: this.baseurl + '/tejiaxiangqing',
            method: 'post',
            params: q
        });
    },

    chakanzancun(q){
        return http({
            url: this.baseurl + '/chakanzancun',
            method: 'post',
            params: q
        });
    },

    deleteRow(spid){
        return http.post(this.baseurl + '/deleteRow?spid='+spid);
    },


    tejiashitulistPage(q){
        return http({
            url: this.baseurl + '/tejiashitulistPage',
            method: 'post',
            params: q
        });
    },

    tejiaCGshitulistPage(q){
        return http({
            url: this.baseurl + '/tejiaCGshitulistPage',
            method: 'post',
            params: q
        });
    },
	
	zhaorencode(q){
	    return http({
	        url: this.baseurl + '/zhaorencode',
	        method: 'post',
	        params: q
	    });
	},


    findotherlistconfig(){
        return http({
            url: this.baseurl + '/findotherlistconfig',
            method: 'post',
        });
    },

    downloadExcelByNum(num){

        updownfile.down(this.tejialist+'/downloadExcelByNum',num,"post",'data');

        // window.location.href =process.env.VUE_APP_AJAXURL + this.baseurl + '/getSpByNumForExcel?vwcode='+vwcode

    },

    updatedelbyid(q){
        return http({
            url: this.fileurl + '/updatedelbyid',
            method: 'post',
            params: q
        });
    },

    tongguoshenhe(q){
        return http({
            url: this.baseurl + '/tongguoshenhe',
            method: 'post',
            params: q
        });
    },

    xuanzerenyuan(){
        return http({
            url: this.baseurl + '/xuanzerenyuan',
            method: 'post',
        });
    },

    anrennaxiangmu(q){
        return http({
            url: this.baseurl + '/anrennaxiangmu',
            method: 'post',
            params: q
        });
    },

    gengxintejia(q){
        return http({
            url: this.baseurl + '/gengxintejia',
            method: 'post',
            params: q
        });
    },
    toshow(pageId,nextShow){
        return http({
            url: '/api/swyl/v1/demo/bscNoviceGuideDetail/isShowNoviceGuide',
            method: 'post',
            params: {pageId,nextShow}
        });
    },

    luojishanchuchanpin(q){
        return http.post( this.tejiachanpin + '/updateById',q);
    },

    getHhAgent(agentCode){
        return http({
            url: '/api/swyl/v1/demo/bscHhptAgentType/getHhAgentList?agentCode='+agentCode,
            method: 'post',
        });
    },


}
